<template>
  <div class="box-tent">
    <div class="box-tent-tit">
      <h3>{{screenName}}</h3>
    </div>
    <div class="echartsy" :id="'chartline' + echartId"></div>
  </div>
</template>

<script>
export default {
  name: 'screen3',
  props: {
    getData: {
      default: function () {
        return {}
      }
    },
    echartId: {},
    screenName: {}
  },
  data () {
    return {
    }
  },
  updated () {
    this.drawEchart()
  },
  mounted () {
    this.drawEchart()
  },
  beforeDestroy () {
  },
  methods: {
    drawEchart () {
      const myEchartst = this.$echarts.init(document.getElementById('chartline' + this.echartId))
      let option = {
        tooltip: {
          show: false
        },
        legend: {
          top: '1%',
          right: '2%',
          textStyle: {
            color: '#fff',
            fontSize: 45
          },
          lineStyle: {
            width: 8
          }
        },
        toolbox: {
          show: false
        },
        grid: {
          left: '6%',
          right: '1%',
          bottom: '3%',
          top: '12%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: true,
          offset: 30,
          axisLabel: {
            color: '#fff',
            rotate: 45,
            fontSize: 32,
            showMinLabel: true, // 强制显示第一个标签
            showMaxLabel: true // 强制显示最后一个标签
          },
          data: this.getData.date
        },
        yAxis: {
          type: 'value',
          offset: 30,
          splitLine: {
            lineStyle: {
              color: '#1F4243'
            }
          },
          axisLabel: {
            color: '#fff',
            fontSize: 32
          }
        },
        series: [
          {
            name: this.getData.name1,
            type: 'line',
            data: this.getData.data1,
            color: '#05DDF2',
            lineStyle: {
              width: 10
            }
          },
          {
            name: this.getData.name2,
            type: 'line',
            data: this.getData.data2,
            color: '#FF9407',
            lineStyle: {
              width: 10
            }
          }
        ]
      }
      myEchartst.setOption(option)
    }
  }
}
</script>
<style scoped>
.box-tent{
  position: absolute;
  width: 116%;
  height: calc(100% - 30px);
  top: 60px;
  left: -8%;
  box-sizing: border-box;
  padding: 0 14% 15% 14%;
  background: url("../../../assets/ale/box-bg.png") no-repeat center/contain
}
.box-tent-tit{
  height: 14%;
  padding-top: 4.5%;
}
.box-tent-tit h3{
  font-size: 70px;
  color: #fff;
  margin-left: 5%;
}
.echartsy{
  width: 1689px;
  height: 762px;
}
</style>



// WEBPACK FOOTER //
// src/views/ale/modules/screen3.vue